{
  "menu": {
    "about": "О нас",
    "facilities": "Удобства",
    "villas": "Виллы и Цены",
    "allRooms": "Все Номера",
    "experiences": "Чем заняться",
    "gallery": "Галерея",
    "news": "Новости",
    "contact": "Контакты",
    "dining": "Ресторан",
    "spa": "Спа"
  },
  "cta": {
    "book": "Забронировать",
    "contact": "Связаться с Нами",
    "back_to_home": "Вернуться на Главную",
    "read_more": "Читать Далее"
  },
  "home": {
    "culture": {
      "subtitle": "Аутентичное балийское наследие",
      "title": "Культурный опыт",
      "desc": "Погрузитесь в богатое духовное и культурное наследие Бали. От священных ритуалов очищения водой до изучения древних традиций, мы будем вашим проводником в путешествии к познанию истинной души острова.",
      "journeySub": "Духовное путешествие",
      "journeyTitle": "Очищение в Сидемене",
      "journeyDesc": "Испытайте традиционный балийский ритуал очищения водой (Мелукат) в священных источниках Сидемена, предназначенный для очищения вашего тела, разума и духа.",
      "btnReserve": "Бронирование"
    },
    "activities": {
      "subtitle": "Избранные моменты",
      "title": "Чем заняться",
      "desc": "Мы предлагаем лучшие тщательно подобранные мероприятия, чтобы создать незабываемые воспоминания во время вашего пребывания. Погрузитесь в магию Бали, от захватывающих приключений до глубоких культурных исследований и духовного оздоровления.",
      "btnView": "Посмотреть развлечения",
      "btnReserve": "Бронирование"
    },
    "different": {
      "subtitle": "Patal Kikian Сидемен",
      "title": "Что делает нас особенными",
      "desc": "Откройте для себя истинную суть скрытой жемчужины. Вдали от толпы мы предлагаем уединенное убежище, где каждая деталь продумана, чтобы помочь вам отключиться, восстановить силы и уехать с прекрасными воспоминаниями на всю жизнь.",
      "card1": {
        "sub": "Частное убежище вдали от мира",
        "title": "Скрытая жемчужина Сидемена",
        "desc": "Спрятанная вдали от шумных улиц, наша вилла предлагает максимальную эксклюзивность и приватность. Здесь вы не просто гость, а привилегированный путешественник, познающий нетронутую безмятежность подлинного Бали."
      },
      "card2": {
        "sub": "Пробудите свои чувства и зарядите свою душу",
        "title": "Обновленная энергия",
        "desc": "Вдохните свежий воздух наших пышных тропических садов и просторных рисовых полей. Каждое мгновение, проведенное в нашей мирной обстановке, призвано омолодить ваш разум, тело и дух."
      },
      "card3": {
        "sub": "Моменты, которые вы будете беречь вечно",
        "title": "Прекрасные воспоминания",
        "desc": "От искренних улыбок до подлинного местного опыта - мы тщательно продумываем каждую деталь вашего пребывания. Возвращайтесь домой не только отдохнувшим, но и с прекрасными, незабываемыми историями, которыми можно поделиться."
      }
    },
    "booking": {
      "title": "Готовы испытать Patal Kikian?",
      "desc": "Проверьте наличие свободных мест и забронируйте свое личное убежище сегодня."
    },
    "contact": {
      "subtitle": "Контакты",
      "title": "Как с нами связаться",
      "desc": "Если у вас есть вопрос о наших номерах, нужна помощь с бронированием или есть особый запрос на предстоящее пребывание, наша преданная команда консьержей готова помочь.",
      "btnEmail": "Отправить Email",
      "btnWa": "Написать в WhatsApp"
    },
    "hero": {
      "subtitle": "Добро пожаловать на виллы Patal Kikian",
      "title": "Проснитесь с самой захватывающей панорамой Бали",
      "description": "Окунитесь в величественное присутствие горы Агунг, возвышающейся над изумрудными рисовыми террасами и пышными холмистыми долинами. Здесь, в мирных объятиях Сидемена, свежий горный воздух и нетронутая безмятежность сплетаются воедино, чтобы создать незабываемое убежище для вашей души."
    },
    "intro": {
      "quote": "\"На протяжении десятилетий пленительная красота Сидемена вдохновляла мир.\"",
      "p1": "В 1938 году легендарный художник Вальтер Шпис увековечил очарование этого региона через свой шедевр <span className=\"italic text-white\">\"Утро в Исехе.\"</span> Картина прекрасно передала возвышающееся величие горы Агунг, пышные изумрудные рисовые террасы, мягкий утренний туман и мирный ритм сельской балийской жизни. И по сей день она остается знаковым символом природного великолепия Бали.",
      "p2": "Сегодня та же самая захватывающая панорама открывается прямо перед вашими глазами на виллах Patal Kikian.",
      "p3": "Каждое утро приносит захватывающий восход солнца, который заливает гору Агунг золотым светом, освещая широкие зеленые долины и принося свежий горный ветерок. Здесь царит спокойствие, заставляя время казаться замедлившимся.",
      "p4": "В Patal Kikian вы не просто останавливаетесь в роскошной вилле; вы погружаетесь в тот самый пейзаж, который очаровал художников, фотографов и любителей природы со всех уголков земного шара.",
      "p5": "Мы предлагаем безупречную гармонию утонченной роскоши, глубокого культурного наследия и аутентичной природной красоты Сидемена.",
      "footerQuote": "Приезжайте в отпуск. Уезжайте с воспоминаниями, о которых вы будете тосковать вечно.",
      "footerBrand": "Виллы Patal Kikian",
      "footerTagline": "Где каждый восход солнца становится шедевром"
    },
    "restaurant": {
      "subtitle": "Patal Kikian Сидемен",
      "title": "Ресторан Patal Kikian",
      "desc": "Наш ресторан, расположенный рядом с пейзажным бассейном и элегантным баром, предлагает замечательный кулинарный опыт в обрамлении потрясающих видов на зеленые долины и обширные рисовые поля. Наслаждайтесь изысканными кулинарными творениями, в то время как легкий ветерок и захватывающая дух природа пробуждают ваши чувства.",
      "callToAction": "Откройте для себя наши изысканные кулинарные предложения. Познакомьтесь с нашими местными и международными фирменными блюдами, посмотрев наше меню, или забронируйте столик для незабываемого ужина.",
      "btnMenu": "Посмотреть меню",
      "btnReserve": "Бронирование",
      "btnTransport": "Бронирование специального транспорта",
      "btnTransportSub": "(Район Сидемена)",
      "btnMaps": "Google Maps",
      "btnMapsSub": "Расположение"
    },
    "spa": {
      "subtitle": "Patal Kikian Сидемен",
      "title": "Спа Patal Kikian",
      "desc": "Омолодите свой разум, тело и душу в спа Patal Kikian. Испытайте подлинные балийские целебные ритуалы и расслабляющий массаж, выполняемые нашими квалифицированными терапевтами, наслаждаясь захватывающей дух природной красотой Сидемена.",
      "callToAction": "Откройте для себя весь спектр наших целостных процедур. Посмотрите наше спа-меню, чтобы изучить наши расслабляющие процедуры, или забронируйте омолаживающий сеанс сегодня.",
      "btnMenu": "Посмотреть меню",
      "btnReserve": "Бронирование",
      "btnTransport": "Бронирование специального транспорта",
      "btnTransportSub": "(Район Сидемена)",
      "btnMaps": "Google Maps",
      "btnMapsSub": "Расположение"
    },
    "rooms": {
      "subtitle": "Patal Kikian Сидемен",
      "title": "Виллы Patal Kikian",
      "desc": "Каждая вилла тщательно спроектирована как ваше личное убежище, откуда открывается захватывающий дух вид на гору Агунг, обширные рисовые поля и пышные зеленые долины, где роскошь плавно сливается с безмятежностью природы."
    }
  },
  "about": {
    "hero": {
      "subtitle": "Наша История",
      "title": "Проснитесь с самой захватывающей панорамой Бали",
      "desc": "Окунитесь в величественное присутствие горы Агунг, возвышающейся над изумрудными рисовыми террасами и пышными долинами. Здесь, в мирных объятиях Сидемена, свежий горный воздух и нетронутая безмятежность создают незабываемое убежище.",
      "btnScroll": "Читать Историю"
    },
    "story": {
      "p1": "Скрытые на окраине Сидемена, Карангасем, виллы Patal Kikian — это больше, чем просто место назначения; это приглашение почувствовать истинное сердцебиение Бали. С панорамным видом с вершины холма каждое утро здесь начинается с симфонии природы: золотой восход солнца, освещающий возвышающуюся вершину горы Агунг, обрамленную бесконечной зеленью и первозданными пейзажами.",
      "p2": "Мы верим, что истинная роскошь кроется в гармонии с природой. Вступая в наше святилище, вы погружаетесь в свежий, чистый горный воздух и глубокое чувство спокойствия. Это место создано для того, чтобы отключить вас от шума мира и воссоединить с тем, что действительно важно.",
      "subtitle": "Гармония природы и культуры",
      "p3": "Наши виллы отражают гармоничное сочетание традиционной балийской архитектуры и современного комфорта, тщательно созданных, чтобы почтить богатую культуру Сидемена. Мы гордимся своим теплым, подлинным гостеприимством. Здесь каждая улыбка искренняя, а каждое обслуживание предоставляется с глубочайшим уважением как к нашим гостям, так и к нашему местному наследию.",
      "quote": "\"Виллы Patal Kikian — это ваш скрытый рай: место, где величественные пейзажи, богатая культура и сердечное гостеприимство сплетают незабываемый гобелен воспоминаний.\"",
      "footer": "Мы с нетерпением ждем возможности приветствовать вас в нашем убежище."
    }
  },
  "facilities": {
    "hero": {
      "subtitle": "Удобства Курорта",
      "title": "Наши Удобства",
      "desc": "Откройте для себя наши первоклассные удобства, предназначенные для обеспечения комфорта и расслабления на протяжении всего вашего пребывания в Сидемене.",
      "btnScroll": "Смотреть Удобства"
    },
    "fallback": {
      "poolSub": "Оазис Безмятежности",
      "poolTitle": "Бассейны",
      "poolDesc1": "Окунитесь в наши кристально чистые панорамные бассейны с видом на яркие тропические сады и пышную долину. Наслаждаетесь ли вы утренним плаванием, плавающим завтраком или просто отдыхаете под солнцем с освежающим коктейлем, наши бассейны предлагают идеальное пространство для расслабления.",
      "poolDesc2": "Для тех, кто ищет уединения, на некоторых виллах также имеются частные мини-бассейны.",
      "restSub": "Кулинарное Совершенство",
      "restTitle": "Ресторан",
      "restDesc1": "Отправьтесь в гастрономическое путешествие в нашем фирменном ресторане под открытым небом. Мы гордимся тем, что подаем аутентичные блюда балийской кухни, а также блюда интернациональной кухни, приготовленные из свежайших местных органических ингредиентов.",
      "restDesc2": "Наслаждайтесь бесплатным завтраком, романтическими ужинами при свечах или непринужденным послеобеденным чаем, любуясь захватывающим видом на окружающую природу.",
      "restBtn": "Узнать больше",
      "spaSub": "Оздоровление и Исцеление",
      "spaTitle": "Роскошный Спа",
      "spaDesc1": "Омолодите свой разум, тело и душу в нашем спокойном спа-салоне. Опираясь на древние балийские традиции исцеления, наши профессиональные терапевты предлагают широкий спектр процедур — от традиционного массажа до восстанавливающих скрабов для тела и ухода за лицом.",
      "spaDesc2": "В качестве нашего гостя вы также получите бесплатный 15-минутный массаж ног по прибытии, чтобы мгновенно снять усталость с дороги.",
      "spaBtn": "Узнать больше"
    }
  },
  "accommodation": {
    "hero": {
      "subtitle": "Наши Номера",
      "title": "Оазис Безмятежности в Patal Kikian Villas",
      "desc": "Испытайте абсолютное спокойствие в наших тщательно продуманных виллах, сочетающих современный комфорт с балийской аутентичностью.",
      "btnScroll": "Смотреть Номера"
    },
    "detail": {
      "loading": "Загрузка деталей номера...",
      "signature": "Фирменный Номер",
      "gallerySub": "Галерея",
      "galleryTitle": "Фотогалерея номера",
      "noImages": "Нет доступных изображений для этого типа номера.",
      "aboutRoom": "О номере",
      "roomSize": "Размер номера",
      "bedSize": "Размер кровати",
      "view": "Вид",
      "amenities": "Удобства",
      "inclusions": "Включено",
      "pleaseNote": "Обратите внимание",
      "roomRules": "Правила и Информация",
      "roomPolicy": "Политика размещения",
      "childrenPolicies": "Политика в отношении детей",
      "childrenPolicyDesc": "Разрешено проживание детей любого возраста. Дети в возрасте до 5 лет включительно могут проживать бесплатно. Размещение детей в возрасте от 6 до 12 лет предоставляется за 151 250,00 индонезийских рупий за ребенка за ночь на дополнительной кровати.",
      "babyCot": "Детская кроватка",
      "babyCotDesc": "Дети в возрасте до 2 лет включительно проживают бесплатно при использовании детской кроватки (при наличии).",
      "extraBed": "Дополнительная кровать",
      "extraBedDesc": "Проживание людей любого возраста обойдется в 302 500,00 индонезийских рупий с человека за ночь при использовании дополнительной кровати (при наличии).",
      "noSmoking": "Курение запрещено.",
      "noPets": "Размещение с домашними животными не допускается.",
      "reserve": "Забронировать",
      "directBooking": "Прямое бронирование у нас",
      "bookOnBooking": "Забронировать на Booking.com",
      "contactConcierge": "Свяжитесь с нашим консьержем по вопросам бронирования и индивидуальных запросов.",
      "otherChoices": "Другие Варианты",
      "otherRooms": "Другие номера, которые могут вам понравиться",
      "bookYourStay": "Забронировать Проживание"
    }
  },
  "luxuryCard": {
    "discover": "Откройте для себя"
  },
  "rooms": {
    "deluxe-bungalow-mountain-view": {
      "title": "Бунгало Делюкс (Вид на горы)",
      "description": "В этом бунгало есть пейзажный бассейн. Это бунгало с отдельным входом и кондиционером состоит из 1 гостиной, 1 отдельной спальни и 1 ванной комнаты с душем и феном. Бунгало обставлено письменным столом и гостиным уголком, а также оснащено мини-баром, принадлежностями для чая/кофе и окнами с видом на сад. В номере 1 кровать.",
      "view": "Вид на сад, бассейн, горы, достопримечательность и реку",
      "roomRules": "Курение: Не курить. Тихие часы после 22:00. Заезд в 14:00, выезд в 12:00."
    },
    "suite-room-mountain-view": {
      "title": "Люкс (Вид на горы)",
      "description": "Гости получат особые впечатления, так как в этом люксе есть бассейн с видом. Этот просторный люкс с отдельным входом также состоит из 1 спальни, гостиного уголка и 1 ванной комнаты с душем и феном. В числе удобств кондиционер, вид на сад, терраса и вино/шампанское для гостей. В номере 1 кровать.",
      "view": "Вид на горы, реку, достопримечательность, бассейн и сад",
      "roomRules": "Курение: Не курить. Тихие часы после 22:00. Заезд в 14:00, выезд в 12:00."
    },
    "private-pool-villa-mountain-view": {
      "title": "Вилла с частным бассейном (Вид на горы)",
      "description": "На этой вилле есть бассейн с видом. Эта вилла с кондиционером и отдельным входом состоит из 1 гостиной, 1 отдельной спальни и 1 ванной комнаты с ванной и душем. Просторная вилла располагает мини-баром, принадлежностями для чая/кофе, гостиным уголком и террасой с видом на сад. В номере 1 кровать.",
      "view": "Вид на сад, бассейн, горы и реку",
      "roomRules": "Курение: Не курить. Тихие часы после 22:00. Заезд в 14:00, выезд в 12:00."
    },
    "features": {
      "Infinity Pool": "Пейзажный Бассейн",
      "Mountain View": "Вид на Горы",
      "Private Balcony": "Частный Балкон",
      "Private Pool": "Частный Бассейн",
      "Mount Agung View": "Вид на гору Агунг",
      "Living Room": "Гостиная",
      "Nature View": "Вид на Природу",
      "Bedroom": "Спальня"
    }
  },
  "experiences": {
    "hero": {
      "subtitle": "Чем заняться",
      "title": "Создайте свои лучшие воспоминания на Бали",
      "desc": "От захватывающих приключений на природе до захватывающего культурного опыта — мы представляем тщательно отобранный выбор мероприятий, которые сделают каждый момент вашего отпуска еще более особенным.",
      "btnScroll": "Смотреть активности"
    },
    "sidebar": {
      "categories": "Категории",
      "moreActivities": "Больше активностей"
    },
    "categories": {
      "Adventure & Nature": "Приключения и Природа",
      "Culture & Art": "Культура и Искусство",
      "Wellness & Spiritual": "Здоровье и Духовность"
    },
    "items": {
      "ATV Adventure": {
        "title": "Приключение на квадроциклах",
        "description": "Испытайте острые ощущения от езды на квадроцикле по прекрасным пейзажам Бали."
      },
      "Cycling Tour": {
        "title": "Велосипедный тур",
        "description": "Прокатитесь на велосипеде по пышным рисовым полям и традиционным деревням с гидом."
      },
      "Rice Terrace Walking Tour": {
        "title": "Прогулка по рисовым террасам",
        "description": "Совершите спокойную прогулку по некоторым из самых знаковых рисовых террас в мире."
      },
      "Sunrise Jeep Mount Batur": {
        "title": "Рассвет на джипе, гора Батур",
        "description": "Станьте свидетелем захватывающего восхода солнца с горы Батур без раннего утреннего похода."
      },
      "Scooter Tour": {
        "title": "Тур на скутерах",
        "description": "Исследуйте скрытые жемчужины Сидемена в захватывающем туре на скутерах с гидом."
      },
      "Rafting": {
        "title": "Рафтинг",
        "description": "Испытайте прилив адреналина во время рафтинга по реке Аюнг."
      },
      "Batur Trekking": {
        "title": "Треккинг на Батур",
        "description": "Поднимитесь на действующий вулкан гора Батур и встретьте рассвет на вершине."
      },
      "Waterfall Tour": {
        "title": "Тур по водопадам",
        "description": "Посетите одни из самых потрясающих и скрытых водопадов в районе Сидемен."
      },
      "Swing": {
        "title": "Качели",
        "description": "Испытайте адреналин от раскачивания высоко над потрясающими долинами и джунглями Бали."
      },
      "Mount Agung Trekking": {
        "title": "Треккинг на гору Агунг",
        "description": "Бросьте себе вызов в захватывающем походе на рассвете на самую высокую вершину Бали, гору Агунг."
      },
      "Cooking Class": {
        "title": "Кулинарный мастер-класс",
        "description": "Узнайте секреты аутентичной балийской кухни у наших опытных местных шеф-поваров."
      },
      "Silver Class": {
        "title": "Серебряный мастер-класс",
        "description": "Создайте свои собственные уникальные серебряные украшения под руководством традиционных мастеров по серебру."
      },
      "Coffee Plantation Tour": {
        "title": "Тур по кофейной плантации",
        "description": "Откройте для себя процесс приготовления традиционного балийского кофе, включая знаменитый кофе Лювак."
      },
      "Yoga & Wellness": {
        "title": "Йога и здоровье",
        "description": "Омолодите свой разум и тело на наших занятиях йогой и оздоровительных сессиях под руководством инструктора."
      }
    }
  },
  "restaurant": {
    "categories": {
      "Appetizers": "Закуски",
      "Soup": "Супы",
      "Pasta": "Паста",
      "Main Course": "Горячие Блюда",
      "Indonesian Food": "Индонезийская Кухня",
      "Dessert": "Десерты",
      "Beverages": "Напитки"
    },
    "hero": {
      "subtitle": "Ресторан Лесной Лист",
      "title": "Успокаивающее Кулинарное Путешествие",
      "desc": "Побалуйте себя изысканными кулинарными творениями, которые питают тело, в сопровождении величественной панорамы горы Агунг...",
      "btnScroll": "Смотреть меню"
    },
    "sidebar": {
      "categories": "Категории",
      "moreCategories": "Больше Категорий"
    },
    "backToHome": "На главную"
  },
  "spa": {
    "categories": {
      "Body Massage": "Массаж Тела",
      "Specialty Treatments": "Специальные Процедуры",
      "Body Scrub and Mask": "Скраб и Маска для Тела",
      "Facial Treatment": "Уход за Лицом",
      "Manicure and Pedicure": "Маникюр и Педикюр",
      "Spa Packages": "Спа-Пакеты"
    },
    "hero": {
      "subtitle": "Добро пожаловать в спа Patal Kikian",
      "title": "Где отдыхает тело, возвращается душа",
      "desc": "Наш спа-центр заботится о вашем уставшем теле, а пышная природа Сидемена обнимает ваше уставшее сердце...",
      "btnScroll": "Смотреть спа-меню"
    },
    "sidebar": {
      "treatments": "Процедуры",
      "moreTreatments": "Больше Процедур"
    },
    "backToHome": "На главную"
  },
  "contact": {
    "hero": {
      "subtitle": "Свяжитесь с нами",
      "title": "Контакты",
      "desc": "Мы здесь, чтобы помочь вам.",
      "scroll": "Свяжитесь с нами"
    },
    "info": {
      "title": "Информация",
      "desc": "У вас есть вопрос или нужна помощь?",
      "address": "Jl. Raya Sidemen, Sinduwati, Бали 80864"
    },
    "form": {
      "title": "Отправьте нам сообщение",
      "name": "Ваше имя",
      "email": "Ваш Email",
      "subject": "Тема",
      "message": "Сообщение",
      "btnSend": "Отправить сообщение",
      "btnSending": "Отправка...",
      "success": "Спасибо! Ваше сообщение отправлено.",
      "error": "Ой! Что-то пошло не так."
    }
  },
  "faq": {
    "q1": {
      "question": "В какое время заезд и выезд?",
      "answer": "Время заезда - 14:00, а выезда - 12:00 (полдень). Ранний заезд или поздний выезд предоставляются при наличии возможности и могут потребовать дополнительной оплаты."
    },
    "q2": {
      "question": "Включен ли завтрак в стоимость номера?",
      "answer": "Да, ежедневный бесплатный завтрак включен во все наши бронирования вилл."
    },
    "q3": {
      "question": "Предоставляете ли вы трансфер из аэропорта?",
      "answer": "Да, мы предлагаем услуги трансфера из аэропорта за дополнительную плату. Пожалуйста, свяжитесь с нами заранее, чтобы организовать встречу."
    },
    "q4": {
      "question": "Подходит ли Patal Kikian для семейного отдыха?",
      "answer": "Хотя мы рады гостям всех возрастов, наша собственность задумана как тихое место для уединения. Родители должны постоянно присматривать за детьми, особенно возле бассейна."
    },
    "q5": {
      "question": "Учитываете ли вы диетические ограничения?",
      "answer": "Абсолютно. Наш ресторан может удовлетворить различные диетические потребности, включая вегетарианские, веганские и безглютеновые блюда. Пожалуйста, сообщите нам о ваших потребностях до прибытия."
    },
    "q6": {
      "question": "Есть ли Wi-Fi на вилле?",
      "answer": "Да, бесплатный высокоскоростной Wi-Fi доступен на всей территории отеля, включая все номера и общественные зоны."
    },
    "subtitle": "Информация",
    "title": "Часто задаваемые вопросы",
    "stillHaveQuestions": "Остались вопросы?",
    "btnContact": "Контакты"
  },
  "terms": {
    "usage": {
      "title": "Использование сайта",
      "p1": "Добро пожаловать на наш сайт. Если вы продолжаете использовать этот сайт, вы соглашаетесь соблюдать следующие условия, которые вместе с нашей политикой конфиденциальности регулируют отношения Patal Kikian Villas с вами.",
      "p2": "Если вы не согласны с какими-либо из этих условий, пожалуйста, не используйте наш сайт.",
      "p3": "Содержание страниц этого сайта предназначено только для общей информации."
    },
    "booking": {
      "title": "Условия бронирования",
      "p1_bold": "Ваш контракт с Patal Kikian Villas:",
      "p1": "Эти Условия бронирования составляют основу вашего контракта с Patal Kikian Villas. Совершая бронирование, вы соглашаетесь соблюдать эти условия.",
      "p2_bold": "Оплата:",
      "p2": "При бронировании вам необходимо предоставить данные кредитной карты или внести залог. В случае незаезда средства будут списаны с вашей карты.",
      "p3_bold": "Точность:",
      "p3": "Мы стремимся обеспечить точность всей информации, но оставляем за собой право исправлять ошибки."
    },
    "cancellation": {
      "title": "Политика отмены",
      "p1_bold": "Стандартные тарифы:",
      "p1": "При отмене менее чем за 14 дней взимается штраф в размере стоимости одной ночи. Менее чем за 7 дней или при незаезде — штраф 100%.",
      "p2_bold": "Невозвратные тарифы:",
      "p2": "Такие бронирования не могут быть отменены без штрафа 100%."
    },
    "copyright": {
      "title": "Авторские права",
      "p1": "Этот сайт и его содержимое защищены авторским правом Patal Kikian Villas. Все права защищены."
    },
    "subtitle": "Легально",
    "title": "Правила и условия"
  },
  "privacy": {
    "policy": {
      "title": "Политика конфиденциальности",
      "p1": "Мы понимаем, что предоставление нам личной информации требует доверия; мы относимся к этому очень серьезно. Эта политика устанавливает, как мы защищаем вашу информацию.",
      "p2": "Мы обязуемся обеспечить защиту вашей конфиденциальности.",
      "p3": "Мы можем время от времени вносить изменения в эту политику, обновляя эту страницу."
    },
    "collect": {
      "title": "Что мы собираем",
      "p1": "Мы можем собирать следующую информацию:",
      "l1": "Имя и контактная информация",
      "l2": "Демографическая информация",
      "l3": "Другая релевантная информация",
      "l4": "Ваш IP-адрес"
    },
    "usage": {
      "title": "Что мы делаем с информацией",
      "p1": "Нам нужна эта информация, чтобы предоставить вам лучший сервис:",
      "l1": "Внутренний учет.",
      "l2": "Для улучшения наших услуг.",
      "l3": "Для рассылки рекламных электронных писем.",
      "l4": "Для персонализации сайта.",
      "p2": "Вы можете отказаться в любое время, написав на info@patalkikianbali.com."
    },
    "security": {
      "title": "Безопасность",
      "p1": "Мы обязуемся обеспечить безопасность вашей информации.",
      "p2_bold": "Финансовая информация:",
      "p2": "Мы не храним данные кредитных карт на наших локальных серверах."
    },
    "cookies": {
      "title": "Использование файлов cookie",
      "p1": "Файлы cookie помогают анализировать веб-трафик. Вы можете принять или отклонить файлы cookie в настройках браузера."
    },
    "subtitle": "Легально",
    "title": "Политика конфиденциальности"
  },
  "footer": {
    "explore": "Исследовать",
    "information": "Информация",
    "desc": "Окунитесь в безмятежную жизнь в Сидемене. Наслаждайтесь потрясающим видом на вулкан Агунг, роскошными виллами и гостеприимством.",
    "translate": "Перевести",
    "quickLinks": "Быстрые ссылки",
    "support": "Поддержка",
    "contactTitle": "Контакты",
    "contact": "Контакты",
    "faq": "ЧаВо",
    "terms": "Правила и условия",
    "privacy": "Политика конфиденциальности",
    "whatsappUs": "Написать в WhatsApp",
    "allRightsReserved": "Все права защищены.",
    "newsJournal": "Новости"
  },
  "news": {
    "journal": "Журнал",
    "latest": "Последние Новости и Истории",
    "subtitle": "Будьте в курсе последних новостей, историй и событий вокруг Патал Кикиан и Сидемен.",
    "readNews": "Читать Новости",
    "allArticles": "Все Статьи",
    "noArticles": "Статьи в этой категории не найдены.",
    "page": "Страница",
    "of": "из"
  },
  "newsSearch": {
    "searchBreadcrumb": "Поиск",
    "searchResults": "Результаты Поиска",
    "searchArticles": "Поиск Статей",
    "resultsFound": "Найдено результатов: {{count}}",
    "forQuery": " по запросу \"{{query}}\"",
    "placeholder": "Поиск статей...",
    "searchBtn": "Поиск",
    "noResults": "Не найдено статей по запросу \"{{query}}\".",
    "enterKeyword": "Введите ключевое слово для поиска.",
    "backToNews": "Назад к Новостям"
  },
  "newsCategory": {
    "category": "Категория",
    "articlesInCat": "статей в этой категории",
    "noArticles": "Статьи в этой категории не найдены.",
    "backToNews": "Назад к Новостям"
  },
  "newsDetail": {
    "tags": "Теги",
    "exclusiveStay": "Эксклюзивное Пребывание",
    "promoDesc": "Испытайте Премиум-Люкс в Сидемене",
    "bookStay": "Забронируйте Свое Пребывание",
    "reserveStay": "Забронируйте Свое Пребывание",
    "villaRecs": "Рекомендации Вилл",
    "recAccommodations": "Рекомендуемые Размещения",
    "readArticle": "Читать Статью",
    "search": "Поиск",
    "searchPlaceholder": "Поиск статей...",
    "go": "Найти",
    "categories": "Категории",
    "popularPosts": "Популярные Статьи",
    "bookNow": "Забронировать",
    "notFound": "Статья Не Найдена",
    "notFoundDesc": "Статья, которую вы ищете, не существует или была перемещена.",
    "backToNews": "Назад к Новостям"
  }
}